import React from "react";
import styles from './data-container.module.scss'
import { PropTypes } from 'prop-types'
import { useNavigate, generatePath } from 'react-router-dom'
import { ongoingProject } from "../../library/constants";
import { Table } from 'antd'


const Projects = ({ items }) => {
    const navigate = useNavigate()
    const handleRowClick = (record) => {
        navigate(generatePath('/production/:id', {
            id: record.id
        }))
    }
    return (
        <div>
            <div className={styles.enquiryHeader}>
                <h3>Production</h3>
            </div>
            <Table
                onRow={(record) => ({
                    onClick: event => {
                        if (event.target.closest('input[type="checkbox"], .ant-checkbox, .ant-checkbox-wrapper')) {
                            return
                        }
                        event.preventDefault()
                        handleRowClick(record)
                    }
                })} className={styles.enquiryBox} dataSource={items} columns={ongoingProject} pagination={false} footer={() => <a onClick={() => { navigate('/production') }} >See More</a>} />
        </div>
    )
}

Projects.propTypes = {
    items: PropTypes.array
}
export default Projects
